<template>
  <div>
    <div class="page-content" >
      <div class="searchBar-wrapper">
        <slot name="custom-searchBar">
          <SearchBar v-bind="searchBar" class="page-searchBar"/>
        </slot>
      </div>
      <!-- 添加等按钮插槽 -->
      <div class="operate-bar" v-if="isHaveOperateBar">
        <slot name="operate-bar" />
      </div>
      <slot name="custom-table">
        <Table v-bind="table" class="page-table" :pagination="pagination" :hiddenOperate="hiddenOperate" @deleteList="deleteList" @dealList="dealList" @selectedRows="selectedRows" >
          <!-- table 操作部分插槽 -->
          <slot name="table-operate" slot-scope="{scope}" slot="operate" :scope="scope" />
          <slot v-for="slot in slots" :name="slot.key" slot-scope="{scope}" :slot="slot.key" :scope="scope" />
        </Table>
      </slot>
      <slot name="custom-pagination">
        <Pagination 
          v-if="pagination.currentPage"
          v-bind="pagination" 
          class="page-pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
        />
      </slot>
    </div>
    <slot />
  </div>
</template>

<script>
/**
 * 模板页面
 * @/view/page.vue
 *
 * pageName       页面名称
 *
 * searchBar
 *  - list        搜索栏配置信息
 *
 * table
 * - selection    是否有选择框
 * - tableInfo    表格Header头信息
 * - tableData    表格数据信息
 * - deleteList   function(list)要删除的信息
 * - dealList     function(list)要批量处理的信息  *需要配置 batchDeal:true
 *
 * pagination
 * - total        总条数
 * - currentPage  当前分页
 * - pageSize     每页条数
 * - currentChange   function(page)
 * - sizeChange      function(pageSize)
 *
 *
 * slot插槽
 * - 自定义搜索栏  custom-searchBar
 * - 自定义table  custom-table    需设置flex-grow: 1, 保证样式统一
 * - 自定义分页  custom-pagination
 */
import Wrapper from './page/Wrapper.vue'
import SearchBar from './page/SearchBar.vue'
import Table from './page/Table.vue'
import Pagination from './page/Pagination.vue'

export default {
  props: {
    pageName: {
      type: String,
      default: ''
    },
    searchBar: {
      type: Object,
      default () {
        return {}
      }
    },
    table: {
      type: Object,
      default () {
        return {}
      }
    },
    pagination: {
      type: Object,
      default () {
        return {}
      }
    },
    hiddenOperate: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Wrapper,
    SearchBar,
    Table,
    Pagination
  },
  data () {
    return {

    }
  },
  computed: {
    paginationInfo () {
      const {currentChange, sizeChange, ...others} = this.pagination
      return others
    },
    slots () {
      const slots = this.table.tableInfo.filter(t => {
        if (t.type === 'custom') {
          return t
        }
      })
      return slots
    },
    isHaveOperateBar () {
      return this.$slots['operate-bar']
    }
  },
  methods: {
    currentChange (page) {
      this.pagination.currentChange && this.pagination.currentChange(page)
    },
    sizeChange (pageSize) {
      this.pagination.sizeChange && this.pagination.sizeChange(pageSize)
    },
    deleteList (list) {
      this.table.deleteList && this.table.deleteList(list)
    },
    dealList (list) {
      this.table.dealList && this.table.dealList(list)
    },
    selectedRows (rows) {
      this.$emit('selectedRows', rows)
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-content {
    // margin: 20px ;
    // flex-grow: 1;
    height:calc(100vh - 265px);
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    .searchBar-wrapper{
      background-color: #eee; 
      // padding-bottom: 20px;
    }
    .page-searchBar{
      background-color: #fff;
      padding: 20px;
      padding-bottom: 0;
    }
    .operate-bar {
      // padding: 20px;
      padding-left: 20px;
    }
    .page-table{
      overflow: auto;
      padding: 20px;
      // padding-top: 0;
    }
    .page-pagination{
      padding-right: 20px;
    }

  }

  ::v-deep{
    .el-form-item{
      margin-bottom: 20px;
    }
    .pagination-container{
      margin-bottom: 0;
    }
    .page-content .page-table{
      padding-right:0;
      padding-left: 0;
    }
    .page-content .page-pagination{
      padding-right: 0;
    }
    .page-content .page-searchBar{
      padding-left: 0;
    }
  }

</style>